module.exports = __webpack_public_path__ + "static/media/ic-attention.5db2fcab.svg";